import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Singleton pattern to prevent multiple GoTrueClient instances
let supabaseInstance: SupabaseClient | null = null;
let supabaseAnonInstance: SupabaseClient | null = null;

// Get or create the main Supabase client (singleton)
function getSupabaseClient(): SupabaseClient {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'noonx-auth-token',
      },
    });
  }
  return supabaseInstance;
}

// Get or create the anonymous Supabase client for OTP operations (singleton)
function getSupabaseAnonClient(): SupabaseClient {
  if (!supabaseAnonInstance) {
    supabaseAnonInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        storageKey: 'noonx-anon-token',
      },
    });
  }
  return supabaseAnonInstance;
}

export const supabase = getSupabaseClient();

// Create a separate client for anonymous OTP operations
// This bypasses authentication issues for unauthenticated users
export const supabaseAnon = getSupabaseAnonClient();